import { ValidationTypes } from "constants/WidgetValidation";

export const propertyPaneContent = [
  {
    sectionName: "Agent",
    children: [
      {
        helpText: "Gives the open AI Agent a name to be displayed in chat",
        propertyName: "assistantName",
        label: "Agent Name",
        controlType: "INPUT_TEXT",
        isJSConvertible: false,
        isBindProperty: false,
        isTriggerProperty: false,
        validation: { type: ValidationTypes.TEXT },
        defaultValue: "",
      },
      {
        helpText: "Configures an initial agent message",
        propertyName: "initialAssistantMessage",
        label: "Welcome Message",
        controlType: "INPUT_TEXT",
        isJSConvertible: true,
        isBindProperty: true,
        isTriggerProperty: false,
        validation: { type: ValidationTypes.TEXT },
        defaultValue: "",
      },
      {
        helpText: "Adds a placeholder text to the message input box",
        propertyName: "promptInputPlaceholder",
        label: "Placeholder",
        controlType: "INPUT_TEXT",
        isJSConvertible: false,
        isBindProperty: false,
        isTriggerProperty: false,
        validation: { type: ValidationTypes.TEXT },
        defaultValue: "",
      },
      {
        helpText: "Configures initial agent suggestions",
        propertyName: "initialAssistantSuggestions",
        label: "Suggested Prompts",
        controlType: "OPTION_INPUT",
        isJSConvertible: true,
        isBindProperty: true,
        isTriggerProperty: false,
        validation: { type: ValidationTypes.ARRAY },
        defaultValue: [],
        controlConfig: {
          allowEmpty: true,
        },
      },
    ],
  },
  {
    sectionName: "Hidden props",
    children: [
      {
        propertyName: "queryData",
        label: "",
        controlType: "INPUT_TEXT",
        isJSConvertible: false,
        isBindProperty: true,
        isTriggerProperty: false,
        hidden: () => true,
      },
      {
        propertyName: "queryRun",
        label: "",
        controlType: "INPUT_TEXT",
        isJSConvertible: false,
        isBindProperty: true,
        isTriggerProperty: false,
        hidden: () => true,
      },
    ],
  },
];
